var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.messages),function(msg,index){return _c('v-alert',{key:index,attrs:{"type":msg.type,"dismissible":msg.dismissible}},[_vm._v(" "+_vm._s(msg.text)+" ")])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }